var style = document.createElement("style");
style.setAttribute("less", "president-primary.less");
style.innerHTML = "president-primary .footnote,\npresident-primary .photo-credit {\n  font-size: 12px;\n  font-style: italic;\n  color: var(--secondary);\n  margin: 2px 0 0 0;\n}\nbody.standalone .photo-credit {\n  display: none;\n}\n";
document.head.appendChild(style);
